export function isAdvancedCarousel(carousel) {
    return (carousel.extendedImages ||
        carousel.displayCarded ||
        carousel.slides?.some((slide) => slide?.description ||
            slide?.overlayImage ||
            slide?.mobileImage ||
            slide?.ctaText ||
            slide?.ctaLink));
}
//# sourceMappingURL=isAdvancedCarousel.js.map